export default {
  GET_INFO: '/ShortUrl/Info',
  INVITE_CODE: '/Invite/InviteCode',
};
